/* TCFJ favorites — saved in the shopper's browser, no third-party app.
   First save from a guest opens the sign-up (Shopify customer form). */
(function () {
  if (window.TCFJFav) return;
  var KEY = 'tcfj-favs', JOINED = 'tcfj-fav-joined', PENDING = 'tcfj-fav-pending';
  var root = document.documentElement;
  var signedIn = root.getAttribute('data-tcfj-customer') === '1';
  function read(k, d) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } }
  function write(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function list() { return read(KEY, []); }
  function has(h) { return list().indexOf(h) > -1; }
  function joined() { return signedIn || read(JOINED, false); }

  function paint() {
    var l = list();
    document.querySelectorAll('[data-tcfj-fav]').forEach(function (b) {
      var on = l.indexOf(b.getAttribute('data-tcfj-fav')) > -1;
      b.classList.toggle('is-saved', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var n = b.getAttribute('data-title') || 'this piece';
      b.setAttribute('aria-label', (on ? 'Remove ' : 'Save ') + n + (on ? ' from favorites' : ' to favorites'));
      var card = b.closest('[data-tcfj-card]'); if (card) card.classList.toggle('is-saved', on);
    });
    document.querySelectorAll('[data-tcfj-fav-count]').forEach(function (el) {
      el.textContent = l.length ? '(' + l.length + ')' : '';
    });
    document.dispatchEvent(new CustomEvent('tcfj:favs', { detail: l }));
  }
  function add(h) { var l = list(); if (l.indexOf(h) < 0) { l.unshift(h); write(KEY, l); } paint(); }
  function remove(h) { write(KEY, list().filter(function (x) { return x !== h; })); paint(); }

  var toastTimer;
  function toast(btn) {
    var t = document.querySelector('[data-tcfj-fav-toast]'); if (!t) return;
    var img = t.querySelector('img'), src = btn && btn.getAttribute('data-img');
    if (img) { if (src) { img.src = src; img.hidden = false; } else img.hidden = true; }
    t.classList.add('is-open'); clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-open'); }, 4000);
  }

  var modal, lastFocus;
  function openModal(handle, btn) {
    modal = document.querySelector('[data-tcfj-fav-modal]'); if (!modal) { add(handle); toast(btn); return; }
    write(PENDING, handle);
    lastFocus = btn;
    modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('tcfj-lock');
    var f = modal.querySelector('input:not([type=hidden])'); f && f.focus();
  }
  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('tcfj-lock');
    lastFocus && lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-tcfj-fav]');
    if (b) {
      e.preventDefault(); e.stopPropagation();
      var h = b.getAttribute('data-tcfj-fav');
      if (has(h)) { remove(h); return; }
      if (!joined()) { openModal(h, b); return; }
      add(h); toast(b); return;
    }
    if (e.target.closest('[data-tcfj-fav-close]')) { e.preventDefault(); closeModal(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) closeModal(); });

  // Sign-up form: with email consent it subscribes (customer form);
  // without it, the details reach the store inbox as a contact message instead.
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('.tcfj-favform'); if (!f) return;
    var email = f.querySelector('[name="contact[email]"]');
    if (!email.value) return;
    var optEmail = f.querySelector('[data-opt-email]').checked;
    var optSms = f.querySelector('[data-opt-sms]').checked;
    var phone = f.querySelector('[name="contact[phone]"]');
    var tags = ['favorites-signup'];
    if (optEmail) tags.push('email-consent');
    if (optSms) tags.push('sms-consent');
    f.querySelector('[name="contact[tags]"]').value = tags.join(', ');
    var ft = f.querySelector('[name="form_type"]');
    var body = f.querySelector('[name="contact[body]"]');
    if (optEmail) { ft.value = 'customer'; body.disabled = true; }
    else {
      ft.value = 'contact'; body.disabled = false;
      var fn = f.querySelector('[name="contact[first_name]"]').value, ln = f.querySelector('[name="contact[last_name]"]').value;
      body.value = 'Favorites sign-up (no email marketing consent).\nName: ' + fn + ' ' + ln + '\nPhone: ' + (phone ? phone.value : '') + '\nText messages: ' + (optSms ? 'yes' : 'no') + '\nSaved piece: ' + (read(PENDING, '') || '');
    }
    var p = read(PENDING, null); if (p) add(p);
    write(JOINED, true);
    // normal submit continues (handles Shopify's spam check); page returns here
  });

  // after the form round trip
  if (/customer_posted=true|contact_posted=true/.test(location.search)) { write(JOINED, true); try { localStorage.removeItem(PENDING); } catch (e) {} }

  window.TCFJFav = { list: list, add: add, remove: remove, has: has, paint: paint };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint); else paint();
  document.addEventListener('shopify:section:load', paint);
})();
